"use strict";

exports.__esModule = true;
exports.CHANGE_UP = exports.CHANGE_THRESHOLD = exports.CHANGE_STABLE = exports.CHANGE_NA = exports.CHANGE_DOWN = void 0;
exports.calculateSlopeValue = calculateSlopeValue;
exports.getChange = getChange;
exports.getChangeIndicator = getChangeIndicator;
var _constants = require("../../constants");
var CHANGE_THRESHOLD = exports.CHANGE_THRESHOLD = 10;
var CHANGE_UP = exports.CHANGE_UP = "UP";
var CHANGE_DOWN = exports.CHANGE_DOWN = "DOWN";
var CHANGE_STABLE = exports.CHANGE_STABLE = "STABLE";
var CHANGE_NA = exports.CHANGE_NA = "CHANGE_NA";
var mean = function mean(elements) {
  return Math.floor(elements.reduce(function (acc, element) {
    return acc + element;
  }, 0) / elements.length);
};
function calculateSlopeValue(rawValues, measurement) {
  // if decimal percentages, multiply by 100
  var values = measurement === _constants.METRICS_FRACTIONAL_PERCENT ? rawValues.map(function (v) {
    return v * 100;
  }) : rawValues;

  // find the index of the middle item
  var isLengthOfValuesEven = values.length % 2;
  var midIdx = isLengthOfValuesEven ? values.length / 2 : (values.length + 1) / 2;
  var meanTillMid = mean(values.slice(0, midIdx));
  var meanOfRest = mean(values.slice(midIdx, values.length));
  if (meanOfRest === meanTillMid) {
    return 0;
  }
  var difference = meanOfRest - meanTillMid;
  var slope = difference / meanTillMid;
  return Number.isFinite(slope) ? slope * 100 : 100;
}
function getChangeIndicator(slope) {
  if (slope > CHANGE_THRESHOLD) {
    return CHANGE_UP;
  } else if (slope < -CHANGE_THRESHOLD) {
    return CHANGE_DOWN;
  }
  return CHANGE_STABLE;
}
function getChange(values, measurement) {
  // no change unless we have 2 or more items to compare
  if (values.length < 2) {
    return CHANGE_NA;
  }
  var slope = calculateSlopeValue(values, measurement);
  return getChangeIndicator(slope);
}